import { useStore } from '../../../../../store/mst';
import { BillingPlanNames } from '../../../../account/Billing/Plans/BillingPlanNamesEnum';

interface DuplicateRouteEligibility {
  canDuplicate: boolean;
  totalOrdersCount: number;
  remainingOrders: number;
  isFreePlan: boolean;
}

const useDuplicateRouteEligibility = (routeUuids: string[]): DuplicateRouteEligibility => {
  const store = useStore();
  const { billing, sortedRoutes } = store;
  const billingPlan = billing?.billingPlan;

  const isFreePlan = billingPlan?.name === BillingPlanNames.FREE;

  // Get total orders count from selected routes
  const selectedRoutes = (sortedRoutes || []).filter(route =>
    route.uuid && routeUuids.includes(route.uuid),
  );

  const totalOrdersCount = selectedRoutes.reduce(
    (sum, route) => sum + (route.totalOrdersCount || 0),
    0,
  );

  const usageLimit = billingPlan?.usageLimit || 0;
  const currentUsage = billingPlan?.currentPeriodUsage || 0;
  const remainingOrders = Math.max(0, usageLimit - currentUsage);

  const canDuplicate = !isFreePlan || totalOrdersCount <= remainingOrders;

  return {
    canDuplicate,
    totalOrdersCount,
    remainingOrders,
    isFreePlan,
  };
};

export default useDuplicateRouteEligibility;
